import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiMutationHook } from '../../common/queryClient/createApiMutationHook';
import { getMutationFn } from '../../common/queryClient/getMutationFn';
import { AccessGroupUrl } from './AccessGroupUrl';
import { AccessGroupDto, AccessGroupValidFormData } from '../schema/types';

const postAccessGroup = (accessGroup: AccessGroupValidFormData) =>
  apiClient
    .post<AccessGroupDto>(expand(AccessGroupUrl.ACCESS_GROUP, {}), accessGroup)
    .then((response) => response.data);

const patchAccessGroup = (
  id: number,
  accessGroup: Partial<AccessGroupValidFormData>,
) =>
  apiClient
    .put<AccessGroupDto>(
      expand(AccessGroupUrl.ACCESS_GROUP, { id }),
      accessGroup,
    )
    .then((response) => response.data);

const deleteAccessGroup = (id: number) =>
  apiClient
    .delete<void>(expand(AccessGroupUrl.ACCESS_GROUP, { id }))
    .then((response) => response.data);

export const useMutateAccessGroup = createApiMutationHook(
  ['access-group'],
  getMutationFn(postAccessGroup, patchAccessGroup, deleteAccessGroup),
);
